export const environment = {
    production: false,
    isExternal: true,
    msalConfig: {
        auth: {
            clientId: 'c8839486-7483-4b81-9d52-08ce1929c860',
            authority: ""
        },
    },
    apiConfig: {
        scopes: ['openid profile offline_access c8839486-7483-4b81-9d52-08ce1929c860'],
        uri: 'https://pplfirst.onmicrosoft.com/c8839486-7483-4b81-9d52-08ce1929c860/app.user',
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
            mfa: 'B2C_1A_STEPUP_MFA'
        },
        authorities: {
            signUpSignIn: {
                authority:
                    'https://pplfirst.b2clogin.com/pplfirst.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
            },
            mfa: {
                authority: 'https://pplfirst.b2clogin.com/pplfirst.onmicrosoft.com/B2C_1A_STEPUP_MFA',
            }
        },
        authorityDomain: 'pplfirst.b2clogin.com',
    },
    apiUrl: 'https://ngenapi-dev.pplfirst.com/external-dev2',
    mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
    wotcUrl: 'https://sandbox.wotc.com/portal/public-partnerships-llc-sandbox/f8850?noStartDate=1',
    apimSubScriptionKey: '8640efe0ac8b4127a87425cc6bd4cc00',
    mfaTimeOutSeconds: 120
};